var React = require('react');

function IconInboundArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m9.385 9.18-.013.785a.622.622 0 0 1-.608.609L1.9 10.69a.573.573 0 0 1-.589-.588l.115-6.862a.622.622 0 0 1 .61-.609l.783-.013a.576.576 0 0 1 .588.603l-.17 4.153 5.16-5.16a.598.598 0 0 1 .848-.014l.555.555c.231.231.225.61-.014.848l-5.16 5.16 4.157-.17a.572.572 0 0 1 .602.588Z"}));
}

IconInboundArrow.defaultProps = {"fill":"currentColor","viewBox":"0 0 11 13"};

module.exports = IconInboundArrow;

IconInboundArrow.default = IconInboundArrow;
